import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const questionApi = createApi({
  reducerPath: 'questionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/questions/`,
  }),
  endpoints: (builder) => ({
    getQuestions: builder.query({
      query: () => ({
        url: `count`,
      })
    }),
    getAll: builder.query({
      query: () => ({
        url: `all`,
      })
    }),
  }),
})

export const { useGetQuestionsQuery, useGetAllQuery } = questionApi